import { useFeatureGate } from "statsig-react";

/**
 * Hook to check if the scheduled publishing feature is enabled for the current user.
 *
 * When enabled, users can schedule tour dates to go live at a specific future date/time.
 * When disabled, users can only publish shows immediately.
 *
 * @returns {boolean} true if scheduled publishing is enabled, false otherwise
 */
export function useScheduledPublishing(): boolean {
  const { gate } = useFeatureGate("scheduled_publishing");
  return gate?.value ?? false;
}
